// Shared Chakra style prop objects for the audit log view. Colors that must
// adapt to color mode are applied in the components via useColorModeValue.

/** Table header cell props (Chakra Th). */
export const HEAD_CELL = {
  borderColor: "transparent",
  fontSize: "10px",
  fontWeight: "700",
  letterSpacing: "0.5px",
  py: "12px",
};

/** Table body cell props (Chakra Td). */
export const BODY_CELL = {
  borderColor: "transparent",
  fontSize: "sm",
  py: "10px",
};

/** Monospace code block props for JSON payloads in the detail drawer. */
export const CODE_BLOCK = {
  fontFamily: "mono",
  fontSize: "xs",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  borderRadius: "10px",
  p: "12px",
  maxH: "260px",
  overflowY: "auto",
};
